import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { ippNavIntrospectAdminAccessControl } from '../access-control/ippNavIntrospectAdminAccess.configuration'

const IppNavIntrospectListNavEntriesPage = lazy(
  () => import('../pages/list-nav-entries/IppNavIntrospectListNavEntriesPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const ippNavIntrospectAdminRouter = (
  <DomainRoute
    route="app-admin-ipp-nav-introspect"
    accessControl={ippNavIntrospectAdminAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-ipp-nav-introspect-list-nav-entries"
        component={IppNavIntrospectListNavEntriesPage}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
